module.exports = __webpack_public_path__ + "img/abbvie-small.76045f72.png";